import * as React from "react";
import CommonDropDown from "../dropdown";
import { useSelector, useDispatch } from "react-redux";
import { getPaystackBanksListAction } from "../../containers/dashboard/action";

function CommonBanksSelect({ value, onChange, ...props }) {
    const dispatch = useDispatch();
    const [options, setOptions] = React.useState([]);
    const paystackBanksList = useSelector((state) => state.dashboardReducer.paystackBanksList);
    const getPaystackBanksListMethod = React.useCallback(() => dispatch(getPaystackBanksListAction({})), [dispatch]);
    React.useEffect(() => {
        if (paystackBanksList?.res?.data?.length !== options.length && !paystackBanksList?.isLoading) {
            getPaystackBanksListMethod();
        }
    }, [getPaystackBanksListMethod, options.length, paystackBanksList?.isLoading]);
    React.useEffect(() => {
        if (paystackBanksList?.res?.data && options.length !== paystackBanksList?.res?.data?.length) {
            setOptions(paystackBanksList?.res?.data?.map(bank => ({ label: bank.name, value: process.env.NODE_ENV === "development" ? bank.code : bank.code })) || []);
        }
    }, [paystackBanksList]);
    return (
        <CommonDropDown
            options={options}
            value={value}
            onChange={onChange}
            placeholder="Select Bank"
            isLoading={paystackBanksList?.isLoading}
            isClearable={true}
            isSearchable={true}
            isDisabled={paystackBanksList?.isLoading || props?.disabled}
            {...props}
        />
    );
}

export default CommonBanksSelect;